import Iconify from 'src/components/Iconify';
import { Badge } from 'src/@/components/ui/badge';

const PURPOSE_LABELS = {
    alugar: 'Aluguel',
    aluguel: 'Aluguel',
    comprar: 'Compra',
    compra: 'Compra',
    vender: 'Venda',
    venda: 'Venda',
};

const DESTINATION_LABELS = {
    residencial: 'Residencial',
    comercial: 'Comercial',
};

function temValor(v) {
    if (v === null || v === undefined) return false;
    if (typeof v === 'string') return v.trim().length > 0;
    if (Array.isArray(v)) return v.length > 0;
    if (typeof v === 'number') return v > 0;
    if (typeof v === 'object') return Object.keys(v).length > 0;
    return !!v;
}

function formatBRL(v) {
    const n = Number(v);
    if (!Number.isFinite(n) || n <= 0) return null;
    return `R$ ${Math.trunc(n).toLocaleString('pt-BR')}`;
}

function normalizeLabel(map, value) {
    if (typeof value !== 'string') return value;
    const key = value.trim().toLowerCase();
    return map[key] || value;
}

function joinList(value) {
    if (Array.isArray(value)) return value.filter(Boolean).join(', ');
    return String(value);
}

function Row({ label, children }) {
    return (
        <div className="flex items-start gap-3 py-1.5">
            <label className="text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:text-[#8b8d90] shrink-0 min-w-[140px] mt-0.5">
                {label}
            </label>
            <div className="text-[13px] font-semibold text-neutral-700 dark:text-[#D1D2D3] flex-1 break-words">
                {children}
            </div>
        </div>
    );
}

export default function DrawerRealEstate({ lead }) {
    const re = lead?.realestate || {};

    const purpose = temValor(re.purpose) ? normalizeLabel(PURPOSE_LABELS, re.purpose) : null;
    const destination = temValor(re.destination) ? normalizeLabel(DESTINATION_LABELS, re.destination) : null;
    const type = temValor(re.type) ? re.type : null;
    const activity = temValor(re.activity_interest) ? re.activity_interest : null;
    const city = temValor(re.city_interest) ? re.city_interest : null;
    const districts = temValor(re.distric_interest) ? joinList(re.distric_interest) : null;
    const metragem = Number(re.metragem_minima) > 0 ? `${re.metragem_minima} m²` : null;
    const price = formatBRL(re.price);
    const quartos = Number(re.quartos) > 0 ? String(re.quartos) : null;
    const vagas = Number(re.vagas) > 0 ? String(re.vagas) : null;
    const caracteristicas = temValor(re.caracteristicas_especiais) ? joinList(re.caracteristicas_especiais) : null;
    const intentions = temValor(re.intentions) ? joinList(re.intentions) : null;

    const hasAny =
        purpose || destination || type || activity || city || districts ||
        metragem || price || quartos || vagas || caracteristicas || intentions;

    if (!hasAny) {
        return (
            <div className="flex flex-col items-center justify-center py-10 text-center mt-2">
                <Iconify icon="mdi:home-search-outline" width={36} className="text-gray-300 dark:text-[#565856] mb-2" />
                <p className="text-sm font-medium text-gray-500 dark:text-[#ABABAD]">
                    Nenhum dado de imóvel coletado ainda
                </p>
                <p className="text-xs text-gray-400 dark:text-[#8b8d90] mt-1">
                    A Lais preenche estas informações ao qualificar o lead
                </p>
            </div>
        );
    }

    return (
        <div className="flex flex-col mt-2">
            {re.sendCrm && (
                <div className="mb-3">
                    <Badge variant="outline" className="text-xs font-medium flex items-center gap-1.5 bg-green-50 text-green-700 border-green-200 dark:bg-green-500/10 dark:text-green-400 dark:border-green-500/30 w-fit">
                        <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
                        Enviado ao CRM parceiro
                    </Badge>
                </div>
            )}

            {purpose && <Row label="Finalidade">{purpose}</Row>}
            {destination && <Row label="Destino">{destination}</Row>}
            {type && <Row label="Tipo de imóvel">{type}</Row>}
            {activity && <Row label="Atividade">{activity}</Row>}
            {city && <Row label="Cidade">{city}</Row>}
            {districts && <Row label="Bairros">{districts}</Row>}
            {price && <Row label="Faixa de preço">{price}</Row>}
            {metragem && <Row label="Metragem mínima">{metragem}</Row>}
            {quartos && <Row label="Quartos">{quartos}</Row>}
            {vagas && <Row label="Vagas">{vagas}</Row>}
            {caracteristicas && <Row label="Características">{caracteristicas}</Row>}
            {intentions && <Row label="Observações">{intentions}</Row>}
        </div>
    );
}
